export const fetchESV = async (
  verseReference: string,
  params: Record<string, string> = {},
  removeStyles?: boolean
) => {
  // Split references by semicolon, trim whitespace
  const references = verseReference.split(';').map((ref) => ref.trim());

  // Add the 'include-passage-references' parameter to the params object
  params['include-passage-references'] = 'false';
  params['include-footnotes'] = 'false';
  params['include-css-link'] = 'false';
  params['inline-styles'] = removeStyles ? 'false' : 'true';

  const token = '9782ddfdad522c19dfe6ff9fd4554060e83d2397';

  // Fetch all references in parallel
  try {
    const passages = await Promise.all(
      references.map(async (ref) => {
        const formattedRef = ref
          .replace(/\s+/g, '+') // Replace spaces with '+'
          .replace(/–/g, '-'); // Replace en dash with hyphen

        const queryString = new URLSearchParams(params).toString();
        const endpoint = `https://api.esv.org/v3/passage/html/?q=${formattedRef}&${queryString}`;

        const response = await fetch(endpoint, {
          headers: {
            Authorization: `Token ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Error fetching verse: ${response.statusText}`);
        }

        const data = await response.json();
        return data.passages
          ? data.passages[0]
          : 'Verse content not available.';
      })
    );

    // Join passages with a separator (e.g., horizontal rule)
    return passages.join('<hr />');
  } catch (error) {
    console.error('Error fetching verse content:', error);
    return 'Error fetching verse content.';
  }
};

export default fetchESV;
